const PASSWORD_RESET_TOKEN_PATTERN = /^(\d+)\.[\da-f]{128}$/;

export const isPasswordResetTokenUsable = (token: string | null): boolean => {
  if (!token) return false;
  const match = PASSWORD_RESET_TOKEN_PATTERN.exec(token);
  if (!match) return false;
  const expiresAt = Number(match[1]);
  return Number.isSafeInteger(expiresAt) && expiresAt > Date.now();
};
